import { ButtonConnect } from "@/components/buttonConnect"
import { Box, IconButton, Link, Stack } from "@mui/material"
import { usePathname } from "next/navigation"
import { useState } from "react"

import NextLink from "next/link"
import LogoIcon from "@/assets/icons/lending-logo.svg"
import navbarLinks from "@/constants/navbarLinks"
import useTrans from "@/hooks/useTrans"
import MenuIcon from "@mui/icons-material/Menu"
import Image from "next/image"
import Drawer from "./drawer"
import Button from "@/components/base/Button"

const View = () => {
  const trans = useTrans()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const routePathname = usePathname()
  const isHome = routePathname === "/home"

  return (
    <>
      <Stack direction='row' spacing={1} sx={{ display: "flex", flexGrow: 1, my: 1 }}>
        <Link underline='none' component={NextLink} href={navbarLinks.home} data-testid='menu-logo'>
          <Box
            sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 0.5 }}
          >
            <Image src={LogoIcon} alt='relend-icon' width={40} height={40} />
          </Box>
        </Link>
      </Stack>
      <Box sx={{ display: "flex", alightItems: "center" }}>
        <Stack direction='row' spacing={1} alignItems='center'>
          {isHome ? (
            <Button variant='primary' size='sm' href={navbarLinks.dashboard}>
              {trans.home.launch_app}
            </Button>
          ) : (
            <ButtonConnect />
          )}

          <IconButton
            edge='start'
            aria-label='menu'
            className='bg-secondary text-primary p-2 rounded'
            onClick={() => setIsDrawerOpen(true)}
          >
            <MenuIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Stack>
        <Drawer isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
      </Box>
    </>
  )
}

export default View
